module.exports = __webpack_public_path__ + "static/img/stair-Img.1781503650204.png";